<template>
    <div class="col-lg-9">
        <div class="d-flex align-items-center mb-4">
            <h4 class="text-7">Events</h4>
            <router-link
                to="/business/events-form"
                class="btn btn-primary btn-sm text-white shadow-none ml-auto"
            >
                <i class="fas fa-plus-circle mr-2"></i>Create Event
            </router-link>
        </div>

        <div v-if="data.content.data.length === 0" class="bg-white rounded shadow-sm p-4">
            <div class="table-responsive">
                <div class="col-sm-12 col-md-12">
                    <div class="hover-border hover-section shadow-sm rounded text-center px-3 py-4">
                        <span class="d-block text-10 text-light mt-2 mb-3">
                          <i class="fas fa-ticket-alt service-icon"></i>
                        </span>
                        <p class="mb-0 text-3 service-text">
                            <b>You do not have any upcoming events</b>
                        </p>
                        <div class="mt-3">
                            <router-link
                                to="/business/events-form"
                                class="btn btn-sm btn-primary text-white shadow-none ml-auto"
                            >
                                Add new event
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="bg-white rounded shadow-sm p-4">
            <!-- Search & Filters -->
            <form @submit.prevent="data.fetch()" class="row mb-4 align-items-center pr-3">
                <div class="col-lg-2">
                    <select
                        @change="data.fetch()"
                        v-model="data.filters.size"
                        class="custom-select"
                        required
                    >
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="25">25</option>
                        <option value="30">30</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                </div>
                <div class="input-group col-lg-4 ml-auto">
                    <div class="input-group-prepend">
                        <span class="input-group-text bg-white">
                          <i class="fas fa-search"></i>
                        </span>
                    </div>
                    <input
                        type="text"
                        class="form-control"
                        v-model="data.filters.search"
                        placeholder="Search...."
                    />
                </div>
                <button
                    @click.prevent="data.fetch()"
                    :class="['btn btn-primary btn-sm text-white px-3 shadow-none', data.loading ? 'btn-loading' : '']"
                >
                    <i class="fas fa-arrow-alt-circle-right"></i>
                </button>
            </form>

            <!-- Events Table -->
            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th class="text-left">Event</th>
                        <th class="text-center">Event Date</th>
                        <th class="text-center">Status</th>
                        <th class="text-center">Sold</th>
                        <th class="text-center">Remaining</th>
                        <th class="text-center">Revenue (USD)</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="row in data.content.data" :key="row.id" @click="goToSummary(row.id)" class="clickable-row">
                        <!-- Event Details Column -->
                        <td style="max-width: 200px;">
                            <div class="event_details">
                                <router-link :to="`/business/events/${row.id}/view`">
                                    <strong>{{ row.name }}</strong>
                                </router-link>
                                <h4 class="text-muted mb-0">
                                    <span class="venue">{{ row.venue }}</span><br />
                                    {{ row.date }} {{ row.time }}
                                </h4>
                            </div>
                        </td>
                        <!-- Event Date Column -->
                        <td class="text-center">
                            <span class="d-block text-4 fw-300">{{ row.event_small_date.split(' ')[0] }}</span>
                            <span class="d-block text-1 fw-300 text-uppercase">{{ row.event_small_date.split(' ')[1] }}</span>
                        </td>
                        <!-- Status Column: Rounded Pill -->
                        <td>
                            <div class="status-pill w-100">
        <span class="status-icon">
  <template v-if="row.display_status === 'TICKETS-PENDING'">
    <i class="fas fa-exclamation-triangle text-danger"></i>
  </template>
  <template v-else-if="row.display_status === 'DRAFT-EVENT'">
    <i class="fas fa-pencil-alt text-primary"></i>
  </template>
  <template v-else-if="row.display_status === 'LIVE-EVENT'">
    <i class="fas fa-check-circle"></i>
  </template>
  <template v-else>
    <i class="fas fa-spinner"></i>
  </template>
</span>

                                <span class="status-text text-1">{{ row.display_status }}</span>
                            </div>
                        </td>

                        <!-- Issued/Remaining Tickets Progress Bar Column -->
                        <td colspan="2">
                            <div class="progress_module">
                                <div class="d-flex justify-content-between progress-labels">
                                    <span>{{ row.issued_tickets }}</span>
                                    <span>{{ row.remaining_tickets }}</span>
                                </div>
                                <div class="progress progress-outline" style="height: 10px; width: 100%;">
                                    <div class="progress-bar bg-primary"
                                         :style="{ width: (row.total_tickets > 0 ? ((row.issued_tickets / row.total_tickets) * 100) : 0) + '%' }">
                                    </div>
                                </div>
                            </div>
                        </td>
                        <!-- Revenue Column -->
                        <td class="text-right">
                            ${{ row.revenue }}
                        </td>
                    </tr>
                    </tbody>
                </table>

                <!-- Pagination & Load More -->
                <div class="d-flex align-items-center mt-5">
                    <div class="mr-auto">
                        Showing {{ data.content.data.length }} of {{ data.content.total }} Records
                    </div>
                    <div>
                        <button
                            @click.prevent="data.append()"
                            v-if="data.content.total !== data.content.to && data.content.data.length > 0"
                            :class="['btn btn-sm btn-primary shadow-none', data.loading ? 'btn-loading' : '']"
                        >
                            <i class="fas fa-arrow-circle-down mr-2"></i>Load More
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import Data from "../../../core/data/Data";
import summary from "./Summary.vue";
export default {
    name: "Index",
    computed: {
        summary() {
            return summary;
        }
    },
    data() {
        return {
            data: new Data({
                url: "/business/events/list",
                prefix: "list"
            })
        };
    },
    mounted() {
        this.data.fetch();
    },
    methods: {
        calculateProgress(row) {
            const issued = Number(row.issued_tickets) || 0;
            const total = Number(row.total_tickets);
            if (total === 0) return "0";
            return ((issued / total) * 100).toFixed(2);
        },
        goToSummary(eventId) {
            this.$router.push(`/business/events/${eventId}/view`);
        }
    }
};
</script>

<style scoped>
.event_details h4 {
    font-size: 0.9rem;
    color: #6c757d;
}
/* Make entire table row clickable */
.clickable-row {
    cursor: pointer;
}
.progress_module {
    width: 100%;
    margin: 0;
}

.progress-labels {
    font-size: 0.85rem;
    margin-bottom: 4px;
}

/* New class for progress outline */
.progress-outline {
    border: 1px solid #ccc;
    border-radius: 4px;
}

/* Updated progress bar styling */
.progress {
    transition: width 0.4s ease-in-out;
}

.status-pill {
    background-color: #eff0f2;
    padding: 0.25rem;
    text-align: center;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center; /* horizontally centers the content */
}

.status-icon {
    color: #28a745;
}

.status-text {
    font-size: 0.875rem;
    margin-left: 0.5rem;
}

.table > tbody > tr > td,
.table > thead > tr > th {
    vertical-align: middle;
    text-align: center;
}

/* Event details remain left aligned */
.event_details {
    text-align: left;
}

/* Optional: Keep the original padding */
.table td,
.table th {
    padding: 0.75rem;
}
</style>
